// Central constants for external URLs & credentials.
// Update here — propagates everywhere.

export const STRIPE_CHECKOUT_URL = 'https://buy.stripe.com/14A28qbsu8eL8dlcbs6g800';
export const MENTORSHIP_CHECKOUT_URL = 'https://buy.stripe.com/28EeVc68a7aH3X54J06g801';
export const DISCOVERY_CALL_URL = 'https://calendly.com/nicolas-gate33/discovery-call';

// Bundle offer — Training + Mentorship. Direct Stripe payment link.
export const BUNDLE_PRICE = '€2,600';
export const BUNDLE_PRICE_STRIKE = '€2,800';
export const BUNDLE_SAVINGS = '€200';
export const BUNDLE_CHECKOUT_URL = 'https://buy.stripe.com/28E7sKfIK52zdxF8Zg6g802';
export const BUNDLE_CHECKOUT_READY = true;

// Payment options — PayPal instalments up to 24×.
export const PAYMENT_OPTIONS_SHORT = 'Pay in full or up to 24× with PayPal';
export const PAYMENT_OPTIONS_FULL = 'Pay in full, or up to 24× payments with PayPal';

// Founder credential — canonical copy across the site.
export const FOUNDER_CREDENTIAL_FULL =
  'Founded by Nicolas Perot dos Santos — Qatar Airways, Etihad, today corporate flight attendant on Bombardier Global and Challenger series aircraft.';
export const FOUNDER_CREDENTIAL_SHORT = 'Global & Challenger aircraft';

// Analytics
export const GA4_MEASUREMENT_ID = 'G-QQDBQNDKX8';
export const LINKEDIN_PARTNER_ID = '9448538';
